module.exports = __webpack_public_path__ + "img/submit-pass.8323c928.png";